import { BillIoFlagEnum } from "./AppEnums"
import { ISelectOptions } from "./AppTypes"

export const PartnerTypeconst = {
	'CUSTOMER': "PARTNER-TYPE.CUS",
	'SUPPLIER': "PARTNER-TYPE.SUP"
}

export const UserTypeEnum = {
	'EMPLOYEE': "user-type.employee", // "内部员工"
	'MICRO_BOSS': "user-type.micro-boss", // "微老板"
	'DRIVER': "user-type.driver", //"司机"
	'HEADMAN': "user-type.headman", //"队长"
	'BOSS': "user-type.boss", // "老板"
	'SUPPLIER': "user-type.supplier", //"供应商"
	'CUSTOMER': "user-type.customer", //"客户"
}

export const TradeTypeEnum = {
	'SALE': "trade-type.sale", //销售,
	'PURCHASE': "trade-type.purchase", //采购
	'SALE_RETURN': "trade-type.sale-return", //销售退货
	'PURCHASE_RETURN': "trade-type.purchase-return", //采采购退货
	'PURCHASE_PLAN': "trade-type.purchase-plan", //采购计划
	'SALE_ORDER': "trade-type.sale-order", //销售订单
	'APPOINTMENT': "trade-type.appointment", //预约
	'MAINTENANCE': "trade-type.maintenance", //维修
	'DISPATCH': "trade-type.dispatch", //派工
	'SETTLE': "trade-type.settle", //结算
	'RETURN_VISIT': "trade-type.return-visit", //回访
	'STOCKTAKING': "trade-type.stocktaking", //盘库
	'LOSS': "trade-type.loss", //损失
	'BILL_DISCOUNT': "trade-type.bill-discount", //账单抹零
}


/**
 * 交易对象类型
 */
export const partnerTypeDs: ISelectOptions[] = [
	{
		label: '客户',
		value: UserTypeEnum.CUSTOMER
	},
	{
		label: '供应商',
		value: UserTypeEnum.SUPPLIER
	},
]

/**
 * 收支类型
 */
export const ioFlagDs: ISelectOptions[] = [
	{
		label: '收',
		value: BillIoFlagEnum.IN
	},
	{
		label: '付',
		value: BillIoFlagEnum.OUT
	},
]

/**
 * 订单收款状态
 */
export const billStatusDs: ISelectOptions[] = [
	{
		label: '初始',
		value: 0
	},
	{
		label: '已记账',
		value: 1
	},
	{
		label: '已核销',
		value: 2
	},
]

/**
 * 结算类型
 */
export enum ISettleTypeEnum {
	SETTLE_CREDIT = "settle-type.credit", //挂账
	SETTLE_CASH = "settle-type.cash"  //现结
}

export const settleTypeDs: ISelectOptions[] = [
	{
		label: '挂账',
		value: ISettleTypeEnum.SETTLE_CREDIT
	},
	{
		label: '现结',
		value: ISettleTypeEnum.SETTLE_CASH
	}
]

export const IWarningTimeDs: ISelectOptions[] = [
	{
		label: '0天',
		value: 0
	},
	{
		label: '5天',
		value: 5
	},
	{
		label: '10天',
		value: 10
	},
	{
		label: '15天',
		value: 15
	},
	{
		label: '20天',
		value: 20
	}
]